import React from 'react';

function SummaryCards({ items, columns = 'sm:grid-cols-2 xl:grid-cols-4' }) {
  return (
    <div className={`grid gap-4 ${columns}`}>
      {items.map((item) => (
        <article key={item.title} className="glass-card-hover p-6">
          {item.icon && <div className="mb-3 text-2xl">{item.icon}</div>}
          <h3 className="mb-2 font-bold text-white">{item.title}</h3>
          <p className="text-sm leading-relaxed text-silver">{item.desc || item.description}</p>
        </article>
      ))}
    </div>
  );
}

export default SummaryCards;
